import { IS_MAC_OS } from "#React/constants/KeyboardShortcuts"
import { onReady } from "#Utils/dom"
import { initializeSidebarCollapsedState, toggleSidebarCollapsed } from "#Utils/sidebarCollapse"

const isEditableTarget = (target) => {
  if (!(target instanceof HTMLElement)) return false

  return (
    target.isContentEditable ||
    ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName) ||
    target.closest('[contenteditable="true"]') !== null
  )
}

const hasReactSidebarToggle = () => {
  return document.querySelector("#react-nav .js-sidebar-collapse-toggle") !== null
}

const isSidebarToggleShortcut = (event) => {
  // Match the physical key so macOS option-modified characters still trigger.
  if (event.code !== "KeyB" || event.shiftKey || !event.altKey) {
    return false
  }

  if (IS_MAC_OS) {
    return event.metaKey && !event.ctrlKey
  }

  return event.ctrlKey && !event.metaKey
}

onReady(() => {
  initializeSidebarCollapsedState()

  document.addEventListener("keydown", (event) => {
    if (hasReactSidebarToggle()) return
    if (isEditableTarget(event.target)) return
    if (!isSidebarToggleShortcut(event)) return

    event.preventDefault()
    toggleSidebarCollapsed()
  })
})
